import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/dropdown/getusers/jv",payload,{
          headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getJvList(payload) {
    const resultuser = await axios.post(apiUrl + "/jv/search/user",payload,{
          headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getUpdateJv(payload) {
    const resultuser = await axios.post(apiUrl + "/jv/update",payload,{
          headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function deleteJv(payload) {
    const resultuser = await axios.post(apiUrl + "/jv/delete",payload,{
          headers: jsonHeader}
    );
    return resultuser.data || [];
}

export const JvLedgerService = {
    getUsers,
    getJvList,
    getUpdateJv,
    deleteJv
}